module.exports = __webpack_public_path__ + "img/w5b.b135a514.jpg";